import { getApiUrl } from "@dashboard/common/utils";

export const fetchUserAddons = async ({ token }: { token: string }) => {
  const response = await fetch(
    `${getApiUrl()}/api/ms/addon/addon-user`, {
    headers: { 'Authorization': `Bearer ${token}`, },
  });
  if (response.status !== 200) return null;
  return await response.json();
};